import { type ComponentType, useEffect } from "react";
import { useLocation } from "react-router";
import { useBreadcrumbTrail } from "./useBreadcrumbTrail.ts";

export const useTrailRoot = (label: string, icon?: ComponentType) => {
  const { resetTrail } = useBreadcrumbTrail();
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    resetTrail(pathname, search, hash, label, icon);
  }, [resetTrail, pathname, search, hash, label, icon]);
};
